const query = `/platform/queries`;
const command = `/platform/commands`;
const auth = `/platform/auth`;

export const API = {
	QUERY: {
		ADMIN: {
			UNKOWN_SECURITIES: `${query}/admin/securities/unknown`,
			UNKNOWN_FUNDS: `${query}/admin/securities/funds/unknown`,
			UNKOWN_RIGHTS: `${query}/admin/securities/rights/unknown`,
			SECURITIES_FINDER: (term: string, filter?: string) =>
				`${query}/admin/securities/finder?term=${term}${
					filter && filter !== "ALL" ? `&types=${filter}` : ""
				}`,
			UNKOWN_TRANSACTIONS: `${query}/admin/transactions/unknown`,
			UNKOWN_DETAIL_TRANSACTIONS: (description: string) =>
				`${query}/admin/transactions/unknown/details?description=${description}`,
			DEMOS: `${query}/admin/demo/users`,
			DEMO_EXECUTIONS: (email: string) => `${query}/admin/demo/users/executions?email=${email}`,
			DEMO_DETAIL: (id: string) => `${query}/admin/demo/users/executions/${id}`,
			CLIENTS: `${query}/admin/clients`,
			CLIENT_DETAIL: (orgId: string) => `${query}/admin/clients/${orgId}/products`,
			DOWNLOAD_CREDENTIAL: (credential: string) =>
				`${query}/admin/connections/${credential}/download`,
			MANAGEMENT_COMPANIES: (
				term: string,
				nullCifOnly: boolean = false,
				page: number = 0,
				size: number = 10
			) =>
				`${query}/admin/management_companies?term=${term}&nullCifOnly=${nullCifOnly}&page=${page}&size=${size}`
		},
		USER: {
			SETTINGS: `${query}/user`
		},
		ORGANIZATIONS: {
			APPS: {
				ALL: (orgId: string) => `${query}/organizations/${orgId}/apps`,
				CONNECTIONS_COUNT: (orgId: string, appId: string, product?: string) =>
					`${query}/organizations/${orgId}/apps/${appId}/connections/count${
						product ? `?product=${product}` : ""
					}`,
				CONNECTIONS_HISTORY: (
					orgId: string,
					appId: string,
					period: string = "7D",
					product?: string
				) =>
					`${query}/organizations/${orgId}/apps/${appId}/connections/history?period=${period}${
						product ? `&product=${product}` : ""
					}`,
				CONFIGURATION: (orgId: string, appId: string) =>
					`${query}/organizations/${orgId}/apps/${appId}/entities`,
				ENTITIES: (orgId: string, appId: string) =>
					`${query}/organizations/${orgId}/apps/${appId}/entities/list`
			},
			SECRETS: {
				ALL: (orgId: string, appId: string) =>
					`${query}/organizations/${orgId}/apps/${appId}/secrets`
			},
			REDIRECTS: {
				ALL: (orgId: string, appId: string) =>
					`${query}/organizations/${orgId}/apps/${appId}/redirects`
			},
			CUSTOMIZATION: (orgId: string, appId: string) =>
				`${query}/organizations/${orgId}/apps/${appId}/themes`,
			USERS: (orgId: string) => `${query}/organizations/${orgId}/users`
		},
		LINK: {
			THEME: `/link/apps/themes`,
			ENTITIES: `/link/apps/entities`,
			TRANSFER_ASSETS: (publicToken: string) =>
				`/link/apps/connections/${publicToken}/assets-transfer`,
			DETAILS: `/link/apps/details`,
			LOGIN_PARAMS: (entityId: string) => `/link/apps/entities/${entityId}/login-params`,
			CONNECTIONS: (updateToken: string) => `/link/apps/connections/${updateToken}`
		},
		DEMO: {
			ENTITIES: `/demo/entities`,
			LOGIN_PARAMS: (entityId: string) => `/demo/entities/${entityId}/login-params`,
			LOGIN_PARAMS2: (entityId: string) => `/demo/entities/${entityId}/login-params`,
			DATA: (token: string) => `/demo/${token}`
		},
		ENTITIES: `${query}/entities`
	},
	COMMAND: {
		ADMIN: {
			UNKOWN_SECURITIES: (id: string) => `${command}/admin/securities/unknown/${id}`,
			UNKOWN_FUNDS: (id: string) => `${command}/admin/securities/funds/${id}`,
			UNKOWN_RIGHT: (id: string) => `${command}/admin/securities/rights/${id}`,
			MANAGEMENT_COMPANIES: `${command}/admin/management_companies`,
			UPDATE_TRANSFERS_FUNDS: `${command}/admin/tax_exempt_funds`,
			DELETE_UNKOWN_TRANSACTIONS: () => `${command}/admin/transactions/unknown/delete`,
			CLIENTS: `${command}/admin/clients`,
			CLIENT_PRODUCTS: (clientId: string) => `${command}/admin/clients/${clientId}/products`,
			DELETE_CLIENT_PRODUCT: (clientId: string, productId: string) =>
				`${command}/admin/clients/${clientId}/products?product=${productId}`,
			CHANGE_ENTITY_MAINTENANCE: (entityId: string, maintenance: boolean) =>
				`${command}/admin/entities/${entityId}/maintenance?maintenance=${maintenance}`,
			UPDATE_ENTITY: `${command}/admin/marketers`,
			UPDATE_MANAGEMENT_COMPANY: `${command}/admin/management_companies/cif`
		},
		ORGANIZATIONS: {
			APPS: {
				CREATE: (orgId: string) => `${command}/organizations/${orgId}/apps`,
				PUT: (orgId: string, appId: string) => `${command}/organizations/${orgId}/apps/${appId}`,
				DELETE: (orgId: string, appId: string) => `${command}/organizations/${orgId}/apps/${appId}`,
				CONFIGURATION: (orgId: string, appId: string) =>
					`${command}/organizations/${orgId}/apps/${appId}/entities`
			},
			WEBHOOK: (orgId: string, appId: string) =>
				`${command}/organizations/${orgId}/apps/${appId}/webhook`,
			SECRETS: {
				CREATE: (orgId: string, appId: string) =>
					`${command}/organizations/${orgId}/apps/${appId}/secrets`,
				DELETE: (orgId: string, appId: string, secretId: string) =>
					`${command}/organizations/${orgId}/apps/${appId}/secrets/${secretId}`
			},
			REDIRECTS: {
				CREATE: (orgId: string, appId: string) =>
					`${command}/organizations/${orgId}/apps/${appId}/redirects`,
				DELETE: (orgId: string, appId: string, id: string) =>
					`${command}/organizations/${orgId}/apps/${appId}/redirects/${id}`
			},
			CUSTOMIZATION: (orgId: string, appId: string) =>
				`${command}/organizations/${orgId}/apps/${appId}/themes`,
			USERS: (orgId: string) => `${command}/organizations/${orgId}/users`,
			DELETE_USER: (orgId: string, userId: string) =>
				`${command}/organizations/${orgId}/users/${userId}`
		},
		LINK: {
			CONNECT_ACCOUNT: `/link/apps/connections`,
			UPDATE_CONNECTION: (updateToken: string) => `/link/apps/connections/${updateToken}`,
			RESTORE_CONNECTION: (restoreToken: string) =>
				`/link/apps/connections/${restoreToken}/restore`,
			START_FLOW: `/link/apps/connections/start-flow`,
			UPDATE_FLOW: (id: string, token: string) =>
				`/link/apps/connections/update-flow?id=${id}&token=${token}`,
			TRANSFER_ASSETS: (publicToken: string) =>
				`/link/apps/connections/${publicToken}/assets-transfer`
		},
		USER: {
			CHANGE_PASSWORD: `${command}/users/security/change_password`
		},
		DEMO: {
			CONNECT_ACCOUNT: `/demo`
		}
	},
	AUTH: {
		LOGIN: `${auth}/login`,
		RECOVER_PASSWORD: `${auth}/recover_pass`,
		RESET_PASSWORD: `${auth}/reset_password`,
		REFRESH_TOKEN: `${auth}/token/refresh`,
		DEMO: {
			REGISTER: `${auth}/demo/register`,
			LOGIN: `${auth}/demo/login`
		}
	}
};
